export default {
	primary: '#3ab8bd'
}


// WEBPACK FOOTER //
// ./src/themes/moderatecyanTheme.js